define('core/Polyfills',[
	'core/polyfills/Object',
	'core/polyfills/Array',
	'core/polyfills/String',
	'core/polyfills/jQuery',
], undefined);

